import React from 'react';

import classes from './Icon.css';

const logo = (props) => (
  <div className={props.iconClass + ' ' + props.className}>
    <img className={classes.Icon} src={props.iconSource} alt={props.iconAlt} />
  </div>
);

export default logo;



// WEBPACK FOOTER //
// ./src/components/UI/Icon/Icon.js